import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HeadWeightNumberBackDto } from '../../api/models/HeadWeightNumberBackDto';

export type TABLE_TYPE = Table<HeadWeightNumberBackDto>;

export const TABLE = 'headWeightNumberBack';
const SCHEMA = 'headWeightNumberBackId';

class HeadWeightNumberBackDatabase implements DataRepository<HeadWeightNumberBackDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<HeadWeightNumberBackDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HeadWeightNumberBackDto, key: Key): Promise<HeadWeightNumberBackDto> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: HeadWeightNumberBackDto[]): Promise<HeadWeightNumberBackDto[]> {
    return this.db.transaction('rw', this.db[TABLE], async () => {
      await this.db[TABLE].clear();
      await this.db[TABLE].bulkPut(payload);
      return payload;
    });
  }

  list(): Promise<HeadWeightNumberBackDto[]> {
    return this.db[TABLE].toArray();
  }
}

export const HeadWeightNumberBackDB = new HeadWeightNumberBackDatabase(db);
